import React, { SVGProps } from 'react';

const SvgBed = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg viewBox='0 0 24 24' fill='currentColor' className='svg-icon' {...props}>
			<path d='M0 0h24v24H0V0z' fill='none' />
			<path
				d='M19 8c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v2h6V8zM11 8c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v2h6V8zM19 12H5c-.55 0-1 .45-1 1v2h16v-2c0-.55-.45-1-1-1z'
				opacity={0.3}
			/>
			<path d='M21 10.78V8c0-1.65-1.35-3-3-3h-4c-.77 0-1.47.3-2 .78-.53-.48-1.23-.78-2-.78H6C4.35 5 3 6.35 3 8v2.78c-.61.55-1 1.34-1 2.22v6h2v-2h16v2h2v-6c0-.88-.39-1.67-1-2.22zM13 8c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v2h-6V8zM5 8c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v2H5V8zm15 7H4v-2c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v2z' />
		</svg>
	);
};

export default SvgBed;
